<template lang="pug">
    .cart.full-height-error.not-valid(v-if="!enabledExtensions.includes('shop')")
        Error(:message="null" :code="403")
    .cart.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    //- Multistore: the record exists and this user may see it, but it belongs to a
    //- different store, so it opens there.
    .cart.full-height-error.full-height-error(v-else-if="foreignStore")
        ForeignStorePanel(
            :store="foreignStore"
            :record-id="$route.params.id"
            record-type="cart"
            back-route="cart-list"
            @switched="reopenAfterStoreSwitch"
        )
    .cart.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .cart(v-else)
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                el-button(
                    circle icon="el-icon-fa-times fas"
                    @click="leave"
                )
                //- el-button(
                //-     circle v-if="! loading && ! inactive"
                //-     type="primary"
                //-     icon="el-icon-fa-check fas"
                //-     :disabled="isDisabledSubmit && ! savingAndClose"
                //-     :loading="savingAndClose"
                //-     @click="submit($event, listRoute)"
                //- )
                //- el-button(
                //-     circle v-if="! loading && ! inactive"
                //-     type="success"
                //-     icon="el-icon-fa-save fas"
                //-     :disabled="isDisabledSubmit && ! saving"
                //-     :loading="saving"
                //-     @click="submit"
                //- )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            //- all-input-fields
            el-card(shadow="always" v-loading="loading")
                router-view.cart-form(:key="$route.path" :class="{'loading-panel': loading}")
            .form-buttons
                el-button(
                    round v-if="! loading"
                    icon="el-icon-fa-times fas"
                    @click="leave"
                ) {{ $t('Dismiss') }}
                //- el-button(
                //-     round v-if="! loading && ! inactive"
                //-     type="primary"
                //-     icon="el-icon-fa-check fas"
                //-     :loading="savingAndClose"
                //-     :disabled="isDisabledSubmit && ! savingAndClose"
                //-     @click="submit($event, listRoute)"
                //- ) {{ $t('Save and close') }}
                //- el-button(
                //-     round v-if="! loading && ! inactive"
                //-     type="success"
                //-     icon="el-icon-fa-save fas"
                //-     :loading="saving"
                //-     :disabled="isDisabledSubmit && ! saving"
                //-     @click="submit"
                //- ) {{ $t('Save') }}
</template>

<i18n>
{
    "de": {
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Cart could not be fetched.": "Warenkorb konnte nicht gefunden werden.",
        "Cart could not be canceled.": "Warenkorb konnte nicht storniert werden.",
        "Cart canceled successfully!": "Warenkorb erfolgreich storniert!",
        "Cart could not be saved.": "Warenkorb konnte nicht gespeichert werden.",
        "Cart saved successfully!": "Warenkorb erfolgreich gespeichert!",
        "Cart Not Found": "Warenkorb nicht gefunden",
        "Articles": "Artikel",
        "Overview": "Übersicht"
    }
}
</i18n>

<script>
import _ from 'lodash';

import router from '@/router';
import pinia from '@/pinia';
import { useSetupStore, useShopCartStore } from '@/stores';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import ForeignStorePanel from '@/components/ForeignStorePanel';
import CartApi from '@/extensions/shop/store/api/cart';

// validate all fields, regardless if the corresponding component is mounted or not
// import AllInputFields from './AllInputFields'

export default {
    name: 'Cart',
    data() {
        return {
            // The store this record belongs to, when it is not the selected one.
            foreignStore: null,
            listRoute: { name: 'cart-list' },
            error: false,
            pathNotValid: false,
            loading: false
            // saving: false,
            // savingAndClose: false,
        };
    },
    components: {
        ForeignStorePanel,
        Tabs,
        Error
        // AllInputFields,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                // The store switch may be exactly what makes this record reachable,
                // so drop the "belongs to another store" panel before refetching -
                // it is checked before the content and would outlive a successful load.
                this.foreignStore = null;
                this.error = false;

                this.setInitializedFlag(false);
                this.initialize();
            }
        }
    },
    computed: {
        id() {
            return _.get(this.form, 'id', false);
        },
        // isDisabledSubmit() {
        //     return this.saving || this.savingAndClose || this.canceling
        // },
        tabs() {
            const id = this.$route.params.id;

            let tabs = [
                {
                    name: this.$t('Overview'),
                    path: `/sales/cart/${id}/main`,
                    icon: {
                        name: 'info-circle',
                        group: 'fas'
                    }
                },
                {
                    name: this.$t('Articles'),
                    path: `/sales/cart/${id}/articles`,
                    icon: {
                        name: 'tags',
                        group: 'fas'
                    }
                }
            ];

            return tabs;
        },
        setupStore() {
            return useSetupStore();
        },
        cartStore() {
            return useShopCartStore(pinia);
        },
        form() {
            return this.cartStore.form;
        },
        options() {
            return this.cartStore.options;
        },
        initialized() {
            return this.cartStore.formInitialized;
        },
        validateOnEnter() {
            return this.cartStore.formValidateOnEnter;
        },
        rules() {
            return this.cartStore.rules;
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        }
    },
    methods: {
        reopenAfterStoreSwitch() {
            this.foreignStore = null;
            this.error = false;
            this.initialize();
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.setInitializedFlag(true);
                return;
            }

            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                const fetchDependencies = () => {
                    let actions = [];

                    this.defineArticlesPaginationSizes([5, 10, 50]);
                    this.defineArticlesPerPage(10);
                    actions.push(
                        this.fetchArticlesPaginated({ scope: 'ex', type: 'shop_cart_article' }).finally(() => {
                            this.updateArticlesLoading(false);
                        })
                    );

                    return Promise.all(actions);
                }

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    this.leave();
                } else if (!isNaN(this.$route.params.id)) {
                    this.fetchCart(this.$route.params.id)
                        .then(() => {
                            // this.cartStore.resetUI()

                            this.loading = false;

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    this.cartStore.resetRules();
                                    // this.cartStore.resetUI()
                                })
                                .catch(handleDependencyError);
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    // Refused because another store is selected? The
                                    // refusal carries that store, so the switch can be
                                    // offered without asking the API a second time.
                                    this.foreignStore = _.get(graphQLErrors, '0.extensions.store') || null;
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Cart Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Cart could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-xmark',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        // submit(event, redirect = false) {
        //
        //     this.$refs.form.validate((valid, errors) => {
        //         if (valid) {
        //             if (redirect) this.savingAndClose = true
        //             else this.saving = true
        //
        //             this.update(this.form)
        //                 .then(() => {
        //                     if (redirect) this.savingAndClose = false
        //                     else this.saving = false
        //
        //                     this.$notify.success({
        //                         title: this.$t('Cart saved successfully!'),
        //                         iconClass: 'fas el-icon-fa-check',
        //                         position: 'bottom-left',
        //                         customClass: 'dark',
        //                         duration: 8000,
        //                     })
        //
        //                     if (redirect) router.push(redirect)
        //                 })
        //                 .catch(err => {
        //                     [> eslint no-console: ["error", { allow: ["error"] }] <]
        //                     console.error(err)
        //
        //                     if (redirect) this.savingAndClose = false
        //                     else this.saving = false
        //
        //                     this.$notify.error({
        //                         title: this.$t('An error occurred!'),
        //                         message: this.$t('Cart could not be saved.'),
        //                         iconClass: 'fas el-icon-fa-xmark',
        //                         position: 'bottom-left',
        //                         customClass: 'dark',
        //                         duration: 8000,
        //                     })
        //                 })
        //         } else {
        //
        //             this.setValidateOnEnterFlag(true)
        //
        //             // check the invalid fields
        //             // and go to the corresponding tab
        //             // or open the corresponding closed area
        //             // TODO: scroll to invalid field
        //
        //             let invalidTabs = []
        //             _.each(errors, (error, path) => {
        //                 if ( _.indexOf(['name'], path) >= 0) {
        //                     invalidTabs.push(`/sales/cart/${this.$route.params.id}/main`)
        //                 }
        //             })
        //
        //             invalidTabs = _.uniq(invalidTabs)
        //
        //             // check if the current tab
        //             // is present in invalidTabs
        //             // if not, go to next (first) invalid tab
        //
        //             const match = _.indexOf(invalidTabs, this.$route.fullPath)
        //
        //             let switchTab = false
        //             if (match < 0) {
        //                 invalidTabs.every(invalidTab => {
        //                     if (invalidTab && this.activeTab !== invalidTab) {
        //                         const tab = _.find(this.tabs, { path: invalidTab })
        //                         if (tab) {
        //                             this.activateTab(tab)
        //
        //                             // break loop after the first tab has been activated
        //                             return false
        //                         }
        //                     }
        //                 })
        //             }
        //
        //             // // triger the validation again
        //             // // so the previously hidden fields will get the errors
        //             // // ---
        //             // // does not work if the component has been destroyed
        //             // // in the meantime (f.a. by switching tabs)
        //             // if (switchTab === false) {
        //             //     const form = this.$refs.form
        //             //     setTimeout(() => {
        //             //         form.validate(() => {
        //             //             // do nothing
        //             //             // callback function is required :(
        //             //         })
        //             //     }, 1000);
        //             // }
        //
        //             this.$notify.warning({
        //                 title: this.$t('Form is not valid!'),
        //                 message: this.$t('Correct your input and submit again.'),
        //                 iconClass: 'fas el-icon-fa-exclamation-circle',
        //                 position: 'bottom-left',
        //                 customClass: 'dark',
        //                 duration: 8000,
        //             })
        //         }
        //     })
        //
        // },
        leave() {
            router.push(this.listRoute);
        },
        setInitializedFlag(value) {
            this.cartStore.setFormInitialized(value);
        },
        setValidateOnEnterFlag(value) {
            this.cartStore.setFormValidateOnEnter(value);
        },
        updateArticlesLoading(value) {
            this.cartStore.updateArticlesPaginationLoading(value);
        },
        defineArticlesPaginationSizes(sizes) {
            this.cartStore.defineArticlesPaginationSizes(sizes);
        },
        defineArticlesPerPage(perPage) {
            this.cartStore.defineArticlesPerPage(perPage);
        },
        activateTab(item) {
            return this.setupStore.activateTab(item);
        },
        fetchCart(id) {
            return this.cartStore.fetchCart(id);
        },
        fetchArticlesPaginated(payload) {
            return this.cartStore.fetchArticlesPaginated(payload);
        }
    },
    beforeRouteEnter(to, from, next) {
        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new';

        if (to.name === 'cart-form') {
            next({ name: 'cart-main', params: { id } });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        setTimeout(() => {
            const cartStore = useShopCartStore(pinia);
            cartStore.reset();
            cartStore.resetUI();
            this.$nextTick(() => cartStore.resetRules());
        }, 300);
    },
    mounted() {
        this.initialize();
    },
    destroyed() {
        // console.log('destroyed');
        // geht nicht .. leert das Formular bei klick auf anderen Reiter
        // store.dispatch('ext_shop_cart/reset')
    }
};
</script>

<style lang="sass" scoped>
.cart:deep()
    .el-card__body
        padding: 0
        & > section
            padding: 20px
    .title
        font-weight: 400
        margin: 0
        margin-bottom: 10px
        .small
            font-size: .8em
            color: $--color-info
    .bordered-table
        // width: 500px
        .min
            width: 1px
        .centered-text
            text-align: center
        .el-icon-warning
            margin-right: 6px
            color: $--color-danger
    .flex
        table.bordered-table.panel
            font-size: 14px
            width: auto
            flex-basis: 300px
            place-self: flex-start
            background: $color-body
            border-color: transparent
            border-radius: 4px
            td
                border-color: transparent
                padding: 6px 15px
            tr:first-of-type
                td
                    padding-top: 10px
            tr:last-of-type
                td
                    padding-bottom: 10px
        table.bordered-table + table.bordered-table
            margin-top: 36px
        .timeline
            min-width: 240px
            margin-top: 30px
            ul
                padding-left: 18px
        +res(lg)
            display: flex
            table.bordered-table + table.bordered-table
                margin-top: 0
                margin-left: 20px
            .timeline
                margin-top: 0
                ul
                    padding-left: 2rem

    .el-timeline-item.success
        .el-timeline-item__tail
            border-color: $--color-success
    .el-timeline-item.half-success
        .el-timeline-item__tail:before
            content: ''
            position: absolute
            left: -2px
            top: 0
            height: 50%
            width: 2px
            background: $--color-success
            border-radius: 2px
</style>
